"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var findWhere = function findWhere(array, predicate) {
  var index = -1;
  var length = array.length;

  // eslint-disable-next-line no-plusplus

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return array[index];
    }
  }

  return undefined;
};

exports.default = findWhere;